import { MathUtils, Vector3 } from "three";
import * as THREE from "three";
var degToRad = MathUtils.degToRad;
export class PerimeterLedLightExtra {
    constructor(scene) {
        this.scene = scene;
        this.data = this.scene.formData;
        this.createPerimeterLightModules();
    }
    createPerimeterLightModules() {
        for (let z = 0; z < this.data.measuredModel.modulesZ; z++) {
            const zPos = z * (this.data.measuredModel.width - this.data.measuredModel.model.edgeWidth);
            this.createPerimeterLight(new Vector3(0, 250, zPos));
            for (let x = 1; x < this.data.measuredModel.modulesX; x++) {
                this.createPerimeterLight(new Vector3(x * this.data.measuredModel.projection, 255, zPos));
            }
        }
    }
    createPerimeterLight(pos) {
        if (this.scene.formData.extras.perimeterLed === false) {
            return;
        }
        const mat = new THREE.MeshBasicMaterial({
            color: 0xF9F8D3,
        });
        const mesh = new THREE.Mesh(new THREE.BoxGeometry(2, 5, this.data.measuredModel.width - 5), mat);
        mesh.layers.enable(1);
        mesh.position.copy(new THREE.Vector3(pos.x - this.data.measuredModel.projection / 2 + this.data.measuredModel.model.edgeWidth / 2, pos.y, pos.z));
        const mesh2 = new THREE.Mesh(new THREE.BoxGeometry(2, 5, this.data.measuredModel.width - 5), mat);
        mesh2.layers.enable(1);
        mesh2.position.copy(new THREE.Vector3(pos.x + this.data.measuredModel.projection / 2 - this.data.measuredModel.model.edgeWidth / 2, pos.y, pos.z));
        const mesh3 = new THREE.Mesh(new THREE.BoxGeometry(2, 5, this.data.measuredModel.projection - 5), mat);
        mesh3.layers.enable(1);
        mesh3.position.copy(new THREE.Vector3(pos.x, pos.y, pos.z - this.data.measuredModel.width / 2 + this.data.measuredModel.model.edgeWidth));
        mesh3.rotateY(degToRad(90));
        const mesh4 = new THREE.Mesh(new THREE.BoxGeometry(2, 5, this.data.measuredModel.projection - 5), mat);
        mesh.layers.enable(1);
        mesh4.position.copy(new THREE.Vector3(pos.x, pos.y, pos.z + this.data.measuredModel.width / 2 - this.data.measuredModel.model.edgeWidth));
        mesh4.rotateY(degToRad(90));
        this.scene.threeScene.add(mesh, mesh2, mesh3, mesh4);
    }
}
